import { HTTP } from "@/axios.js"
import store from '@/store.js'
export default {
    workScheduleList: (shift_id) => {
        return HTTP.get('/work_schedule?shift_id='+shift_id, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },  
    shiftList: () => {
        return HTTP.get('/work_schedule/shift_get', {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },    
}